<template>
  <div class="correction-system-mobile" v-loading.fullscreen.lock="loading">
    <HeaderSectionMobile :classManagementForm="classManagementForm" :subjectIndex="subjectIndex" @switch-to-next-class="handleSwitchToNextClass" />
    
    <div v-if="!isSubjectBound && bindingInfo" class="binding-content">
      <p>本班级{{ bindingInfo.subjectName }}科目还没有绑定老师，任选以下两个方式之一让{{ bindingInfo.subjectName }}老师绑定本班，<br/>您也可以点击：<el-button 
          @click="switchSubject" 
          class="subject-toggle-btn-inline"
          :class="subjectClass"
          style="color: white; width: 60px; height: 30px; font-size: 12px; padding: 4px; margin: 0 5px; box-shadow: 0 2px 4px rgba(0,0,0,0.2); cursor: pointer;">
          切换科目
        </el-button>来继续切换科目。</p>
      <div class="binding-methods">
        <div class="method">
          <h4>方式一：</h4>
          <p>{{ bindingInfo.subjectName }}老师手机扫描下方二维码加入</p>
          <div v-if="bindingQrCodeUrl" class="qr-code-container">
            <img :src="bindingQrCodeUrl" alt="绑定二维码" class="qr-code" />
          </div>
        </div>
        <div class="method">
          <h4>方式二：</h4>
          <p>复制下方链接给{{ bindingInfo.subjectName }}老师加入：</p>
          <div class="binding-link">
            <span class="link-text">{{ bindingInfo.pcBindingLink }}</span>
            <el-button size="mini" type="primary" @click="copyPcLink">复制链接</el-button>
          </div>
        </div>
      </div>
    </div>
    
    <template v-else>
      <ControlPanelMobile 
          ref="controlPanel"
          :classId="classId"
          :subjectIndex="subjectIndex"
          :students="students"
          :classManagementForm="classManagementForm"
          :selectedType.sync="selectedType"
          :currentDate.sync="currentDate"
          :homeworkContent.sync="homeworkContent"
          :homeworkTypes="homeworkTypes"
          :correctionRecords="correctionRecords"
          :showUnfinishedCount="showUnfinishedCount"
          :finishedCount="finishedCount"
          :unfinishedCount="unfinishedCount"
          :isAssigned="isAssigned"
          @loadData="loadData"
          @loadUnfinishedCounts="loadUnfinishedCounts"
          @reset-status="handleResetStatus"
          @set-all-finished="handleSetAllFinished"
          @toggle-unfinished-count="toggleUnfinishedCount"
          @switch-subject="switchSubject"
          @homework-assigned="handleHomeworkAssigned"
        />
        
        <div class="main-content">
          <StudentGridMobile 
            :students="students"
            :correctionRecords="correctionRecords"
            :currentDate="currentDate"
            :selectedType="selectedType"
            :classId="classId"
            :subjectIndex="subjectIndex"
            :showUnfinishedCount="showUnfinishedCount"
            :studentUnfinishedCounts="studentUnfinishedCounts"
            :isAssigned="isAssigned"
            :studentsLoading="studentsLoading"
            :showUnfinishedCountBadge="showUnfinishedCountBadge"
            @record-updated="handleRecordUpdated"
            @update-stats="updateStats"
            @load-unfinished-counts="loadUnfinishedCounts"
            @check-student-history="handleCheckStudentHistory"
          />
        </div>
    </template>
  </div>
</template>

<script>
import Utils from '../../utils/Utils.js'
import HeaderSectionMobile from '@/components/mobile/HeaderSectionMobile.vue'
import ControlPanelMobile from '@/components/mobile/ControlPanelMobile.vue'
import StudentGridMobile from '@/components/mobile/StudentGridMobile.vue'
import logoutMixin from '@/mixins/logoutMixin.js'

export default {
  name: 'CorrectionSystemMobileNew',
  mixins: [logoutMixin],
  components: {
    HeaderSectionMobile: HeaderSectionMobile,
    ControlPanelMobile: ControlPanelMobile,
    StudentGridMobile: StudentGridMobile
  },
  props: {
    classId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      loading: true,
      currentDate: this.getCurrentDate(),
      students: [],
      homeworkTypes: [],
      selectedType: 1,
      homeworkContent: '',
      correctionRecords: [],
      finishedCount: 0,
      unfinishedCount: 0,
      subjects: ['语文', '数学', '英语'],
      subjectIndex: 0,
      // 欠交数量显示状态
      showUnfinishedCount: false,
      // 学生欠交数量数据
      studentUnfinishedCounts: {},
      // 作业是否已布置
      isAssigned: true,
      // 学生数据加载状态
      studentsLoading: false,
      // 欠交数量角标显示状态
      showUnfinishedCountBadge: true,
      // 科目绑定状态相关
      isSubjectBound: true,
      bindingInfo: null,
      bindingQrCodeUrl: null,
      // 班级管理表单
      classManagementForm: {
        classCode: '',
        grade: null,
        classNumber: null,
        chineseHomeworkTypes: [],
        mathHomeworkTypes: [],
        englishHomeworkTypes: [],
        students: []
      },
      // 我的班级列表
      myClasses: []
    };
  },
  computed: {
    currentSubject() {
      return this.subjects[this.subjectIndex];
    },
    subjectClass() {
      switch(this.subjectIndex) {
        case 0:
          return 'chinese-subject';
        case 1:
          return 'math-subject';
        case 2:
          return 'english-subject';
        default:
          return 'math-subject';
      }
    },
    currentDateOffset() {
      return Utils.calculateDateOffset(this.currentDate);
    }
  },
  watch: {
    currentDate(newVal) {
      sessionStorage.setItem('selectedDate', newVal);
    },
    selectedType(newVal) {
      sessionStorage.setItem('selectedType', newVal);
    },
    subjectIndex(newVal) {
      this.applySubjectTheme();
      this.$emit('subjectChange', newVal);
      
      if (this.$route.query.subjectId !== (newVal + 1).toString()) {
        this.$router.replace({
          ...this.$route,
          query: {
            ...this.$route.query,
            subjectId: newVal + 1
          }
        }).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            throw err;
          }
        });
      }
    }
  },
  
  async mounted() {
    const savedDate = sessionStorage.getItem('selectedDate');
    const savedType = sessionStorage.getItem('selectedType');
    
    if (savedDate) {
      this.currentDate = savedDate;
    }
    
    const routeSubjectId = this.$route.query.subjectId;
    if (routeSubjectId) {
      const subjectId = parseInt(routeSubjectId);
      if (subjectId !== 1 && subjectId !== 2 && subjectId !== 3) {
        this.logoutAndRedirect('/loginmobile');
        return;
      }
      this.subjectIndex = subjectId - 1;
    } else {
      this.logoutAndRedirect('/loginmobile');
      return;
    }
    
    this.applySubjectTheme();
    
    await this.loadStudents();
    await this.loadBasicClassInfo();
    
    this.classManagementForm.students = this.students;
    
    await this.loadClassManagementData();
    
    await this.loadHomeworkTypes();
    
    await this.loadMyClasses();
    
    if (savedType) {
      const typeId = parseInt(savedType);
      if (this.homeworkTypes.some(type => type.id === typeId)) {
        this.selectedType = typeId;
      } else {
        if (this.homeworkTypes.length > 0) {
          this.selectedType = this.homeworkTypes[0].id;
        }
      }
    } else {
      if (this.homeworkTypes.length > 0) {
        this.selectedType = this.homeworkTypes[0].id;
      }
    }
    
    this.loadData();
    
    this.checkSubjectBinding();
    
    document.addEventListener('contextmenu', (event) => {
      if (event.target.classList.contains('student-btn') || event.target.closest('.student-btn')) {
        return;
      }
      event.preventDefault();
    });
  },
  
  methods: {
    getCurrentDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
    
    // 根据当前日期设置高亮的快捷按钮
    setHighlightedShortcut() {
      Utils.setHighlightedShortcut(this);
    },
    
    // 加载班级管理数据
    async loadClassManagementData() {
      try {
        if (this.classId) {
          // 只加载当前科目的作业类型（使用新接口）
          const currentSubjectId = this.subjectIndex + 1;
          const currentSubjectResponse = await this.$http.get(`/homeworkTypes/class?classId=${this.classId}&subjectId=${currentSubjectId}`);
          
          // 根据当前科目设置对应的作业类型列表
          switch(this.subjectIndex) {
            case 0: // 语文
              this.classManagementForm.chineseHomeworkTypes = currentSubjectResponse.data || [];
              break;
            case 1: // 数学
              this.classManagementForm.mathHomeworkTypes = currentSubjectResponse.data || [];
              break;
            case 2: // 英语
              this.classManagementForm.englishHomeworkTypes = currentSubjectResponse.data || [];
              break;
            default:
              break;
          }
          
          // 注意：学生名单已经在loadStudents方法中加载，这里不需要重复加载
          // 仅在classManagementForm.students为空时才加载，避免重复请求
          if (!this.classManagementForm.students || this.classManagementForm.students.length === 0) {
            const studentsResponse = await this.$http.get(`/students/class?classId=${this.classId}`);
            this.classManagementForm.students = studentsResponse.data || [];
          }
        }
      } catch (error) {
        console.error('加载班级管理数据失败:', error);
      }
    },
    
    // 强制更新日期选择器高亮状态
    forceUpdateDatepickerHighlight() {
      Utils.forceUpdateDatepickerHighlight(this);
    },
    
    // 加载基本班级信息
    async loadBasicClassInfo() {
      try {
        if (this.classId) {
          const response = await this.$http.get(`/classes/${this.classId}`);

          // 检查响应结构
          let classInfo;
          if (response.data && response.data.success && response.data.class) {
            // 格式：{success: true, class: {...}}
            classInfo = response.data.class;
          } else if (response.data && response.data.id) {
            // 格式：{id: 1, classCode: "...", gradeLevel: 5, classNumber: "4班"}
            classInfo = response.data;
          }
          
          if (classInfo) {
            // 更新班级管理表单中的基本信息
            this.classManagementForm.grade = classInfo.gradeLevel;
            
            // 解析班级编号
            const classNumberStr = classInfo.classNumber ? classInfo.classNumber.toString() : "";
            const parsedClassNumber = parseInt(classNumberStr.match(/\d+/)?.[0]);
            if (!isNaN(parsedClassNumber)) {
              this.classManagementForm.classNumber = parsedClassNumber;
            }
          }
        }
      } catch (error) {
        console.error('加载班级基本信息失败:', error);
      }
    },
    
    // 加载我的班级列表
    async loadMyClasses() {
      try {
        const response = await this.$http.get('/teachers/myClasses');
        if (response.data.success && response.data.classes) {
          this.myClasses = response.data.classes.map(cls => ({
            id: cls.id,
            name: cls.name,
            subjectName: cls.subjectName,
            subjectId: cls.subjectId
          }));
        }
      } catch (error) {
        console.error('加载我的班级失败:', error);
      }
    },
    
    // 切换到下一个班级
    handleSwitchToNextClass() {
      if (!this.myClasses || this.myClasses.length === 0) {
        this.$message.warning('没有可切换的班级');
        return;
      }
      
      const currentIndex = this.myClasses.findIndex(c => c.id === this.classId);
      const nextIndex = (currentIndex + 1) % this.myClasses.length;
      const nextClass = this.myClasses[nextIndex];
      
      const subjectId = nextClass.subjectId;
      window.location.href = `/mobile/class/${nextClass.id}?subjectId=${subjectId}`;
    },
    
    applySubjectTheme() {
      // 移除所有主题类
      document.body.classList.remove('chinese-theme', 'math-theme', 'english-theme');
      
      // 根据当前科目添加对应的主题类
      switch(this.subjectIndex) {
        case 0: // 语文 - 深黄色主题
          document.body.classList.add('chinese-theme');
          break;
        case 1: // 数学 - 蓝色主题
          document.body.classList.add('math-theme');
          break;
        case 2: // 英语 - 粉红色主题
          document.body.classList.add('english-theme');
          break;
        default:
          document.body.classList.add('math-theme');
      }
    },
    loadStudents() {
      // 根据是否有classId来决定请求的URL
      let url = '/students';
      
      // 如果有classId，使用class接口
      if (this.classId) {
        url = `/students/class?classId=${this.classId}`;
      }
      
      return this.$http.get(url)
        .then(response => {
          this.students = response.data;
        });
    },
    loadHomeworkTypes() {
      // 优先使用已加载的数据，避免重复请求
      if (this.classId) {
        // 根据当前科目索引获取对应的作业类型列表
        let homeworkTypes;
        switch(this.subjectIndex) {
          case 0: // 语文
            homeworkTypes = this.classManagementForm.chineseHomeworkTypes;
            break;
          case 1: // 数学
            homeworkTypes = this.classManagementForm.mathHomeworkTypes;
            break;
          case 2: // 英语
            homeworkTypes = this.classManagementForm.englishHomeworkTypes;
            break;
          default:
            homeworkTypes = [];
        }
        
        // 如果已存在对应科目的作业类型数据，则直接使用
        if (homeworkTypes && homeworkTypes.length > 0) {
          this.homeworkTypes = homeworkTypes;
          // 如果当前选中的作业类型不在新的列表中，则重置为第一个类型
          if (this.homeworkTypes.length > 0 && !this.homeworkTypes.some(type => type.id === this.selectedType)) {
            this.selectedType = this.homeworkTypes[0].id;
          }
          return Promise.resolve();
        } else {
          // 如果没有缓存的数据，则发起请求
          const url = `/homeworkTypes/class?classId=${this.classId}&subjectId=${this.subjectIndex + 1}`;
          return this.$http.get(url)
            .then(response => {
              this.homeworkTypes = response.data;
              // 如果当前选中的作业类型不在新的列表中，则重置为第一个类型
              if (this.homeworkTypes.length > 0 && !this.homeworkTypes.some(type => type.id === this.selectedType)) {
                this.selectedType = this.homeworkTypes[0].id;
              }
            });
        }
      } else {
        // 没有classId时，仍然发起请求
        const url = `/homeworkTypes/class?subjectId=${this.subjectIndex + 1}`;
        return this.$http.get(url)
          .then(response => {
            this.homeworkTypes = response.data;
            // 如果当前选中的作业类型不在新的列表中，则重置为第一个类型
            if (this.homeworkTypes.length > 0 && !this.homeworkTypes.some(type => type.id === this.selectedType)) {
              this.selectedType = this.homeworkTypes[0].id;
            }
          });
      }
    },
    loadData() {
      this.studentsLoading = true;
      this.showUnfinishedCountBadge = false;
      
      this.checkIsAssigned().then(() => {
        // 构建基础URL参数
        let correctionRecordsUrl = `/correctionRecords?date=${this.currentDate}&typeId=${this.selectedType}`;
        let homeworkContentsUrl = `/homeworkContents?date=${this.currentDate}&typeId=${this.selectedType}`;
        
        // 如果有classId，添加到URL中
        if (this.classId) {
          correctionRecordsUrl += `&classId=${this.classId}`;
          homeworkContentsUrl += `&classId=${this.classId}`;
        }
        
        // 加载作业内容
        this.$http.get(homeworkContentsUrl)
          .then(response => {
            this.homeworkContent = response.status === 204 ? '' : (response.data?.content || '');
          })
          .catch(() => {
            this.homeworkContent = '';
          });
        
        // 只有在已布置作业时才加载订正记录
        if (this.isAssigned) {
          // 加载订正记录
          this.$http.get(correctionRecordsUrl)
            .then(response => {
              this.correctionRecords = response.data;
              this.updateStats();
            })
            .finally(() => {
              this.finishLoading(this.showUnfinishedCount ? this.loadUnfinishedCounts() : null);
            });
        } else {
          this.correctionRecords = [];
          
          // 如果正在显示欠交数量，则同时加载统计数据和欠交数量
          const promises = [this.updateStatsPromise()];
          if (this.showUnfinishedCount) {
            promises.push(this.loadUnfinishedCounts());
          }
          
          Promise.all(promises).finally(() => {
            this.finishLoading();
          });
        }
      });
    },
    finishLoading(unfinishedPromise = null) {
      const finish = () => {
        this.$nextTick(() => {
          this.studentsLoading = false;
          this.showUnfinishedCountBadge = true;
        });
      };
      
      if (unfinishedPromise) {
        unfinishedPromise.then(finish).catch(finish);
      } else {
        finish();
      }
    },
    updateStats() {
      let url = `/correctionRecords/statistics?date=${this.currentDate}&typeId=${this.selectedType}`;
      
      // 如果有classId，添加到URL中
      if (this.classId) {
        url += `&classId=${this.classId}`;
      }
      
      this.$http.get(url)
        .then(response => {
          this.finishedCount = response.data.finished;
          this.unfinishedCount = response.data.unfinished;
          // 数据加载完成，隐藏loading
          this.loading = false;
        });
    },
    updateStatsPromise() {
      let url = `/correctionRecords/statistics?date=${this.currentDate}&typeId=${this.selectedType}`;
      
      // 如果有classId，添加到URL中
      if (this.classId) {
        url += `&classId=${this.classId}`;
      }
      
      return this.$http.get(url)
        .then(response => {
          this.finishedCount = response.data.finished;
          this.unfinishedCount = response.data.unfinished;
          // 数据加载完成，隐藏loading
          this.loading = false;
        });
    },
    handleRecordUpdated(record) {
      this.correctionRecords.push(record);
    },
    handleCheckStudentHistory(student) {
      this.$refs.controlPanel.handleSelectStudent(student);
    },
    saveHomeworkContent() {
      let url = `/homeworkContents?date=${this.currentDate}&typeId=${this.selectedType}`;
      
      // 如果有classId，添加到URL中
      if (this.classId) {
        url += `&classId=${this.classId}`;
      }
      
      this.$http.get(url)
        .then(response => {
          // 检查响应状态码，204表示无内容
          let content;
          if (response.status === 204) {
            content = {};
          } else {
            content = response.data || {};
          }

          content.date = this.currentDate;
          content.homeworkTypeId = this.selectedType;
          content.content = this.homeworkContent;
          
          // 如果有classId，添加到内容中
          if (this.classId) {
            content.classId = this.classId;
          }

          return this.$http.post('/homeworkContents', content);
        })
        .then(response => {
          // 保存成功后的处理
          this.$message({
            type: 'success',
            message: '作业内容保存成功!'
          });
        })
        .catch(() => {
          // 新建
          const content = {
            date: this.currentDate,
            homeworkTypeId: this.selectedType,
            content: this.homeworkContent
          };
          
          // 如果有classId，添加到内容中
          if (this.classId) {
            content.classId = this.classId;
          }
          
          return this.$http.post('/homeworkContents', content)
            .then(response => {
              // 保存成功后的处理
              this.$message({
                type: 'success',
                message: '作业内容保存成功!'
              });
            })
            .catch(error => {
              // 保存失败的处理
              this.$message({
                type: 'error',
                message: '作业内容保存失败: ' + (error.response?.data?.message || error.message || '未知错误')
              });
            });
        });
    },
    resetStatus() {
      this.$confirm('此操作将重置本页面订正状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: this.subjectClass + '-confirm'
      }).then(() => {
        let url = `/correctionRecords/reset?date=${this.currentDate}&typeId=${this.selectedType}`;
        if (this.classId) {
          url = `/correctionRecords/reset?date=${this.currentDate}&typeId=${this.selectedType}&classId=${this.classId}`;
        }
        this.$http.put(url)
          .then(() => {
            this.loadData();
            // 如果开启了欠交数量显示，则更新欠交数量
            if (this.showUnfinishedCount) {
              this.loadUnfinishedCounts();
            }
            this.$message({
              type: 'success',
              message: '重置成功!'
            });
          });
      });
    },
    setAllFinished() {
      this.$confirm('此操作将设置本页面所有学生为订正完成状态, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let url = `/correctionRecords/setAllFinished?date=${this.currentDate}&typeId=${this.selectedType}`;
        if (this.classId) {
          url = `/correctionRecords/setAllFinished?date=${this.currentDate}&typeId=${this.selectedType}&classId=${this.classId}`;
        }
        this.$http.put(url)
          .then(() => {
            this.loadData();
            // 如果开启了欠交数量显示，则更新欠交数量
            if (this.showUnfinishedCount) {
              this.loadUnfinishedCounts();
            }
            this.$message({
              type: 'success',
              message: '设置成功!'
            });
          })
          .catch(error => {
            console.error('设置全部完成失败:', error);
            this.$message({
              type: 'error',
              message: '设置失败: ' + (error.response?.data?.message || '未知错误')
            });
          });
      });
    },
    handleResetStatus() {
      this.resetStatus();
    },
    handleSetAllFinished() {
      this.setAllFinished();
    },
    switchSubject() {
      // 切换科目
      this.subjectIndex = (this.subjectIndex + 1) % this.subjects.length;
      // 重新加载作业类型和数据
      this.loadHomeworkTypes().then(() => {
        // 确保选中的作业类型在新的科目下存在
        if (this.homeworkTypes.length > 0 && !this.homeworkTypes.some(type => type.id === this.selectedType)) {
          this.selectedType = this.homeworkTypes[0].id;
        }
        this.loadData();
        
        // 切换科目后检查新的绑定状态
        this.checkSubjectBinding();
        
        // 更新URL参数中的subjectId
        const newSubjectId = this.subjectIndex + 1;
        // 检查当前subjectId与目标subjectId是否不同，避免重复导航
        if (parseInt(this.$route.query.subjectId) !== newSubjectId) {
          this.$router.push({
            ...this.$route,
            query: { ...this.$route.query, subjectId: newSubjectId }
          }).catch(err => {
            // 忽略重复导航错误
            if (err.name !== 'NavigationDuplicated' && err.name !== 'RedirectedError') {
              // 如果是其他错误，重新抛出
              throw err;
            }
          });
        }
      });
    },
    toggleUnfinishedCount() {
      // 切换欠交数量显示
      this.showUnfinishedCount = !this.showUnfinishedCount;
      if (this.showUnfinishedCount) {
        this.loadUnfinishedCounts();
      }
    },
    loadUnfinishedCounts() {
      // 加载学生欠交数量
      let url = `/correctionRecords/unfinishedCountBySubject?subjectId=${this.subjectIndex + 1}`;
      if (this.classId) {
        url += `&classId=${this.classId}`;
      }
      
      return this.$http.get(url)
        .then(response => {
          const counts = {};
          response.data.forEach(item => {
            counts[item.studentId] = item.unfinishedCount;
          });
          this.studentUnfinishedCounts = counts;
        });
    },
    checkSubjectBinding() {
      if (!this.classId) {
        console.warn('No classId available for checking subject binding');
        return;
      }

      const subjectId = this.subjectIndex + 1;

      this.$http.get(`/teacherClass/checkBinding?classId=${this.classId}&subjectId=${subjectId}`)
          .then(response => {
            this.isSubjectBound = response.data.bound;
            this.bindingInfo = response.data;

            if (!this.isSubjectBound) {
              this.generateBindingInfo();
            }
          })
          .catch(error => {
            console.error('检查科目绑定状态失败:', error);
          });
    },

    async generateBindingInfo() {
      const subjectId = this.subjectIndex + 1;

      try {
        const response = await this.$http.get(`/teacherBinding/generateBindingCode?classId=${this.classId}&subjectId=${subjectId}`);

        if (response.data.success) {
          const baseUrl = window.location.origin;
          const mobileUrl = baseUrl + response.data.mobileEndpoint;
          const pcUrl = baseUrl + response.data.pcEndpoint;

          const qrCodeApi = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(mobileUrl)}`;
          this.bindingQrCodeUrl = qrCodeApi;

          this.bindingInfo = {
            subjectName: this.currentSubject,
            bindingLink: mobileUrl,
            pcBindingLink: pcUrl
          };
        } else {
          console.error('生成绑定代码失败:', response.data.message);
        }
      } catch (error) {
        console.error('请求绑定代码失败:', error);
      }
    },

    copyPcLink() {
      if (this.bindingInfo && this.bindingInfo.pcBindingLink) {
        const textToCopy = this.bindingInfo.pcBindingLink;
        
        // 尝试使用 Clipboard API
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(textToCopy)
            .then(() => {
              this.$message({
                type: 'success',
                message: '链接复制成功!'
              });
            })
            .catch(() => {
              // Clipboard API 失败，尝试备用方案
              this.fallbackCopyText(textToCopy);
            });
        } else {
          // 不支持 Clipboard API，使用备用方案
          this.fallbackCopyText(textToCopy);
        }
      }
    },
    
    fallbackCopyText(text) {
      // 创建临时文本框
      const textArea = document.createElement('textarea');
      textArea.value = text;
      textArea.style.position = 'fixed';
      textArea.style.left = '-9999px';
      textArea.style.top = '0';
      textArea.style.opacity = '0';
      document.body.appendChild(textArea);
      
      try {
        textArea.select();
        textArea.setSelectionRange(0, 99999);
        
        const successful = document.execCommand('copy');
        if (successful) {
          this.$message({
            type: 'success',
            message: '链接复制成功!'
          });
        } else {
          this.$message({
            type: 'error',
            message: '链接复制失败，请手动复制!'
          });
        }
      } catch (err) {
        console.error('复制失败:', err);
        this.$message({
          type: 'error',
          message: '链接复制失败，请手动复制!'
        });
      } finally {
        document.body.removeChild(textArea);
      }
    },
    
    // 检测是否已布置作业
    async checkIsAssigned() {
      if (!this.classId || !this.currentDate || !this.selectedType) {
        this.isAssigned = true;
        return;
      }
      
      try {
        const response = await this.$http.get(`/homeworkAssignments/check?classId=${this.classId}&date=${this.currentDate}&homeworkTypeId=${this.selectedType}`);
        this.isAssigned = response.data.assigned;
      } catch (error) {
        console.error('检测作业布置状态失败:', error);
        this.isAssigned = true;
      }
    },
    
    // 处理作业布置成功事件
    handleHomeworkAssigned() {
      this.isAssigned = true;
      this.loadData();
    }
  }
}
</script>

<style scoped>
@import './correction-system-mobile.css';
</style>

<style>
/* 主题色确认对话框样式 */
.chinese-subject-confirm.el-message-box .el-message-box__header {
  background: linear-gradient(135deg, #ff9800 0%, #ff6d00 100%) !important;
}

.chinese-subject-confirm.el-message-box .el-message-box__title {
  color: #fff !important;
}

.chinese-subject-confirm.el-message-box .el-message-box__btns .el-button--primary {
  background: linear-gradient(135deg, #ff9800 0%, #ff6d00 100%) !important;
  border-color: #ff6d00 !important;
}

.math-subject-confirm.el-message-box .el-message-box__header {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%) !important;
}

.math-subject-confirm.el-message-box .el-message-box__title {
  color: #fff !important;
}

.math-subject-confirm.el-message-box .el-message-box__btns .el-button--primary {
  background: linear-gradient(135deg, #2196f3 0%, #1976d2 100%) !important;
  border-color: #1976d2 !important;
}

.english-subject-confirm.el-message-box .el-message-box__header {
  background: linear-gradient(135deg, #e91e63 0%, #c2185b 100%) !important;
}

.english-subject-confirm.el-message-box .el-message-box__title {
  color: #fff !important;
}

.english-subject-confirm.el-message-box .el-message-box__btns .el-button--primary {
  background: linear-gradient(135deg, #e91e63 0%, #c2185b 100%) !important;
  border-color: #c2185b !important;
}
</style>